import React from "react";
import "./Myline.css";
const MyLine = () => {
  return (
    <div className="contain">
      <div className="Myline"></div>
    </div>
  );
};

export default MyLine;
